export default __webpack_public_path__ + "static/media/forward.4d2a7df9.svg";